// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"LazyVideo_videoContainer__aVs0Q"};